import type { DocNode } from '@atlaskit/adf-schema';

export const defaultDocument: DocNode = {
	version: 1,
	type: 'doc',
	content: [
		{
			type: 'paragraph',
			content: [],
		},
	],
};
